import React, { Component } from 'react'
import {
  FaWindows as Windows,
  FaLinux as Linux,
  FaDatabase as Sql,
} from 'react-icons/fa'
import Loader from 'react-loader-advanced'
import HttpClient from "../../../libs/http";
const http = new HttpClient()
const queryString = require('query-string')
var worker = null

export default class IddleInstances extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [],
      loaded: false,
      lastUpdated: null,
    }
  }
  async componentWillMount() {
    await this.getData()
    worker = setInterval(this.getData, 30000)
  }
  componentWillUnmount() {
    if (worker) clearInterval(worker)
  }
  getData = async () => {
    const { state } = this
    var query = queryString.parse(window.location.search)
    const response = await http.GET(
      '/api/pvt/ducktales/iddle-resources' +
      '?region=' +
      (query.region || '*') +
      '&account=' +
      (query.account || '*') +
      '&platform=' +
      (query.platform || '*') +
      '&type=' +
      (query.type || '*')
    )
    state.items = response.data
    state.lastUpdated = new Date(response.updated).toString('HH:mm:ss')
    state.loaded = true
    this.setState(state)
  }
  each = (item, index) => {
    return (
      <div key={'instance' + item.region + index} className='dib w-100 b--black-10  pa1 pa2-ns pb2 pb2-sn white-60'>
        <InstanceIddle {...item} />
      </div>
    )
  }
  render() {
    return (
      <Loader
        show={!this.state.loaded}
        message={'Loading...'}
        backgroundStyle={{ backgroundColor: 'black' }}
      >
        <div className="flex-l">
          <div className="flex flex-wrap flex-row-m justify-between justify-around-xl w-100-l h-100">
            <div className="fl w-100 pa1 link center shadow-5">
              <div className="fl w-30 f3 fw5 pa2">Application</div>
              <div className="fl w-20 f4 pa2 bl pl4">Owner</div>
              <div className="fl w-10 f4 pa2 bl pl4 tc">View AWS</div>
              <div className="fl w-15 f4 pa2 bl pl4">Instance Type</div>
              <div className="fl w-25 f4 pa2">
                <div className="fl w-30 f4 pa2 bl pl4">Iddle</div>
                <div className="fl w-30 f4 pa2 bl pl4">Max Usage</div>
                <div className="fl w-40 f4 pa2 bl pl4 tr">Monthly</div>
              </div>
            </div>
            {this.state.items.map(this.each)}
          </div>
        </div>
      </Loader>
    )
  }
}
const InstanceIddle = item => {
  const platform = item.platform.toLowerCase()
  return (
    <div className="fl w-100 pa1 card link center ba shadow-5 br1 bg-light-marine">
      <div className="fl w-30 f3 fw5 pa2"><strong>{item.name}</strong></div>
      <div className="fl w-20 f4 pa2 bl pl4">{item.owner}</div>
      <div className="fl w-10 f4 pa2 bl tc"><a className="white link" href={`https://console.aws.amazon.com/ec2/v2/home?region=us-east-1#Instances:search=${item.instances.map(x=>x.id).join(',')};sort=desc:tag:Name`}>EC2</a></div>
      <div className="fl w-15 f4 pa2 bl pl4">{platform.includes("sql") ? <Sql className="f4" /> : false}{platform.includes("windows") ? <Windows className="f4" /> : false}{platform.includes("linux") ? <Linux className="f4" /> : false}{` ${item.type}`}</div>
      <div className="fl w-25 f4 pa2">
        <div className="fl w-30 f4 pa2 bl pl4">{item.count}</div>
        <div className="fl w-30 f4 pa2 bl pl4">{parseInt(item.maxUsage)}%</div>
        <div className="fl w-40 f4 pa2 bl pl4 tr">$ {item.cost.monthly.toFixed(2)}</div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Ducktales/IddleInstances/index.js